<section class="about-hero surface-contour">
  <div class="container">
    <h1 class="page-title" @fadeInOut>About Restless Society</h1>
    <p class="page-subtitle" @fadeInOut>A gathering point for a shared rhythm</p>
  </div>
</section>

<section class="about-content">
  <div class="container">
    <div class="content-text" @fadeInOut>
      <app-about-summary [condensed]="false"></app-about-summary>

      <img src="/restless-mark.png" alt="Restless Society" class="logo-image" width="240" height="114">
    </div>
  </div>
</section>

<section class="join-section">
  <div class="container">
    <h2 class="join-title" #joinTitle>Join Our Community</h2>
    <p class="join-text">
      Become part of something greater. Connect with passionate individuals, 
      share your ideas, and grow together with <span class="restless-highlight">Restless</span> Society.
    </p>
    <button class="btn btn-primary join-button" (click)="navigateToSubscribe()">
      Get Started Today
    </button>
  </div>
</section>